import { useQuery } from 'react-query';
import { getEmployeeDetails } from 'RestAPIs/employees/details';

const useGetEmployeeDetails = (employeeId: number) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['employeeDetails', 'list', employeeId],
    async () => {
      const { data } = await getEmployeeDetails({ employeeId });
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeDetails;
